export const ORG_NAME_MAX_LENGTH = 25;

export enum BaseL3ConfigEnum {
  Default = 'Default',
  Custom = 'Custom',
  Testnet = 'Testnet',
  Mainnet = 'Mainnet',
  Eigen = 'Eigen',
  Celestia = 'Celestia',
}
